export type LoopMergeTagValue =
  | { status: "empty" }
  | { status: "invalid" }
  | { status: "ok"; data: Record<string, unknown>[] };

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * The loop editor in the merge-tag preview panel takes free text. The
 * backend only expands a loop whose data is a non-empty array, so anything
 * else must be reported here instead of being sent as a string.
 */
export function parseLoopMergeTagValue(
  raw: string | null | undefined
): LoopMergeTagValue {
  const text = (raw ?? "").trim();
  if (!text) return { status: "empty" };

  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    return { status: "invalid" };
  }

  if (isPlainObject(parsed)) {
    const keys = Object.keys(parsed);
    if (keys.length === 1 && Array.isArray(parsed[keys[0]])) {
      parsed = parsed[keys[0]];
    }
  }

  if (!Array.isArray(parsed)) return { status: "invalid" };
  if (parsed.length === 0) return { status: "empty" };
  if (!parsed.every(isPlainObject)) return { status: "invalid" };

  // Values keep their JSON types (numbers, booleans, null); the backend
  // stringifies them when it fills a loop row (fillRowPlaceholders).
  return { status: "ok", data: parsed };
}
